import {useAppSelector} from "../../../../../../redux/hooks";
import {
  getMySongsPageSongSelectedSongDetailsArtistName,
  getMySongsPageSongSelectedSongDetailsGenre,
  getMySongsPageSongSelectedSongDetailsImageUrl,
  getMySongsPageSongSelectedSongDetailsName
} from "../../../../modules/my-songs-page-store/mySongsPage.selectors";
import {isDefined} from "../../../../../../util/is-type";
import {useSongDetailsRouterParams} from "../../hooks/useSongDetailsRouterParams";
import {deviceStore} from "../../../../../../redux/device/deviceStore";

export interface ISongDetailsTitleBarLogic {
  imageUrl?: string;
  name?: string;
  artistName?: string;
  genre?: string;
  backButtonLabel: string;
}

export const useSongDetailsTitleBarLogic = (): ISongDetailsTitleBarLogic => {
  const imageUrl = useAppSelector(getMySongsPageSongSelectedSongDetailsImageUrl);
  const name = useAppSelector(getMySongsPageSongSelectedSongDetailsName);
  const artistName = useAppSelector(getMySongsPageSongSelectedSongDetailsArtistName);
  const genre = useAppSelector(getMySongsPageSongSelectedSongDetailsGenre);
  const isMobile = useAppSelector(deviceStore.getDeviceIsMobile);
  const {lessonId} = useSongDetailsRouterParams();
  const isBackButtonModifiedForMobile = isMobile && isDefined(lessonId);
  const backButtonLabel = isBackButtonModifiedForMobile ? `Arrangements` : `Songs`;

  return {
    imageUrl,
    name,
    artistName,
    genre,
    backButtonLabel,
  };
}
